import { useRef, useState } from 'react';
import useStore from '../stores/useStore.jsx';

const Joystick = () => {
  const setJoystickInput = useStore((state) => state.setJoystickInput);
  const containerRef = useRef(null);
  const [stickPosition, setStickPosition] = useState({ x: 0, y: 0 });
  const [active, setActive] = useState(false);

  const handleTouch = (e) => {
    if (!containerRef.current) return;

    const touch = e.touches[0];
    const rect = containerRef.current.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;
    const radius = rect.width / 2;

    let deltaX = touch.clientX - centerX;
    let deltaY = touch.clientY - centerY;

    const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
    const maxDistance = radius;

    if (distance > maxDistance) {
      deltaX = (deltaX / distance) * maxDistance;
      deltaY = (deltaY / distance) * maxDistance;
    }

    setStickPosition({ x: deltaX, y: deltaY });
    // Normalize input to -1 to 1
    setJoystickInput({ x: deltaX / maxDistance, y: -deltaY / maxDistance });
  };

  const handleTouchStart = (e) => {
    e.stopPropagation();
    setActive(true);
    handleTouch(e);
  };

  const handleTouchMove = (e) => {
    e.stopPropagation();
    if (active) {
      handleTouch(e);
    }
  };

  const handleTouchEnd = (e) => {
    e.stopPropagation();
    setActive(false);
    setStickPosition({ x: 0, y: 0 });
    setJoystickInput({ x: 0, y: 0 });
  };

  return (
    <div className="absolute z-50 bottom-[calc(2rem+env(safe-area-inset-bottom))] left-[calc(2rem+env(safe-area-inset-left))] select-none touch-none">
      <div
        ref={containerRef}
        className="w-32 h-32 bg-black/20 rounded-full flex items-center justify-center border-2 border-white/30 backdrop-blur-sm"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <div
          className="w-12 h-12 bg-white/80 rounded-full shadow-lg transition-transform duration-75"
          style={{
            transform: `translate(${stickPosition.x}px, ${stickPosition.y}px)`,
          }}
        />
      </div>
    </div>
  );
};

export default Joystick;
